import React from 'react';
import Visibility from '../../components/Visibility';
import { Description, SubTitle } from '../../components/layouts';
import { Chart } from '../../components/Chart';
import './style.scss';

export function PerfMobile2() {
  const [chartActive, setChartActive] = React.useState(false);
  const handleUpdate = React.useCallback(
    (e, { calculations }) => {
      const { percentagePassed } = calculations;
      setChartActive(percentagePassed > -0.2 && percentagePassed < 1.2);
    },
    [setChartActive]
  );
  return (
    <Visibility fireOnMount offset={[-500, 500]} onUpdate={handleUpdate} className="page-section section-perf-mobile inverted">
      <div className="sticky-content" style={{ overflow: 'visible' }}>
        <div>
          <div className="section-content left">
            <SubTitle>
              超快闪存UFS 3.1
              <br />
              大文件，秒读
            </SubTitle>
            <Description>超高清电影、视频及超大文件都能够快速读取，轻松满足大家的运行和存储需求，提供更加顺畅的运行体验。</Description>
            <Chart
              active={chartActive}
              className="chart-2"
              prev={{
                value: 16,
                total: 37,
                valueLabel: '108%',
                title: (
                  <span>
                    顺序读取速度提升<sup>6</sup>
                  </span>
                )
              }}
              next={{
                value: 37,
                total: 37,
                valueLabel: '513%',
                title: (
                  <span>
                    顺序写入速度提升<sup>6</sup>
                  </span>
                )
              }}
            />
          </div>
        </div>
      </div>
    </Visibility>
  );
}
